import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import React, { Fragment, useContext, useEffect, useState } from "react";
import BuyTicketWrapper from "../components/BuyTicketWrapper";
import PayJp from "../components/PayJp";
import BreadCrumbs from "../components/BreadCrumbs";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { httpGet } from "../lib/apiClients";
import CouponWrapper from "../components/CouponWrapper";
import LoaderComponent from "../components/LoaderComponent";
import BuyType from "../components/BuyType";
import SectionHeader from "../components/SectionHeader";
import { UserDataContext } from "../context/UserDataContext";
import { ArrowBack } from "@material-ui/icons";
import BreadCrumbLinks from "../components/BreadCrumbLinks";
import ConcernTextArea from "../components/ConcernTextArea";
interface ChargeData {
  couponList: [];
  product: any | null | undefined;
  creditcard: object | null | undefined;
  staff: any;
}

export default function BuyPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  const { state } = useLocation();
  const [chargeData, setChargeData] = useState<ChargeData | undefined>(
    undefined
  );
  const [couponData, setCouponData] = useState<object | undefined>(undefined);
  const [concernText, setConcernText] = useState("");
  const [concernTextError, setConcernTextError] = useState(false);
  const { getCouponData, fetchCoupon } = useContext(UserDataContext);
  const [buyType, setBuyType] = useState<string>("TEL");
  const productId = searchParams.get("productId")
    ? searchParams.get("productId")
    : undefined;
  const reserveNowParam = searchParams.get("reserveNow")
    ? searchParams.get("reserveNow")
    : false;
  const staffIdParam = searchParams.get("staffId")
    ? searchParams.get("staffId")
    : false;
  if (!productId) {
    navigate("/support/menu");
  }
  useEffect(() => {
    document.title = "支払い画面 | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    } else {
      fetchCoupon();
      getChargeData();
    }
  }, [currentUser]);
  /**
   * Get Charge Data
   */
  const getChargeData = async () => {
    const params = {
      productId: productId,
    };
    if (staffIdParam) {
      params["staffId"] = staffIdParam;
    }
    try {
      await httpGet({
        pathName: "charge-data",
        queryParams: { ...params },
      }).then((response) => {
        var data = response.data;
        setChargeData(data);
        console.log(data);
        if (!reserveNowParam) {
          if (data.product.productType == "SUPPORT" && !state) {
            navigate("/support/menu", { state: { displayToast: true } });
          }
        }
      });
    } catch (error) {
      console.log(error.response.data.message);
      if (
        error?.response?.status == 400 &&
        error.response.data.message == "Staff Not Found."
      ) {
        navigate("/error?code=404");
      } else if (error.response.status >= 400 && error.response.status <= 499) {
        navigate("/support/menu", { state: { displayToast: true } });
      } else {
        navigate(
          `/error?code=${error.response.status ? error.response.status : "400"}`
        );
      }
    }
  };
  function handleBackToStaffPage() {
    navigate(`/support/staff?productId=${state.ticket.productId}`, {
      state: { ticket: state.ticket },
    });
  }
  console.log(getCouponData);
  return (
    <Box className="buy-page">
      {chargeData ? (
        <Fragment>
          {chargeData?.product?.productType == "SUPPORT" &&
            reserveNowParam == false && (
              <BreadCrumbLinks
                currentPage={"お支払い"}
                cf={handleBackToStaffPage}
              />
            )}

          <Box className="section-50 bg-dots " component={"section"}>
            {!["INTERVIEW", "TIP", "ADD"].includes(
              chargeData.product.productType
            ) && reserveNowParam == false ? (
              <BreadCrumbs currentPage={"お支払い"} preHeading="Payment" />
            ) : (
              <SectionHeader currentPage={"お支払い"} preHeading="Payment" />
            )}

            <Container className="container">
              <Typography className="page-description">
                お申し込み内容で注文を確定します
                <br />
                チケット購入手続きをお願いいたします。
              </Typography>
              <Typography className="section-heading">
                お申し込み内容
              </Typography>
              {chargeData && (
                <BuyTicketWrapper
                  product={chargeData.product}
                  state={state}
                  couponData={couponData}
                  staffData={chargeData.staff}
                />
              )}
            </Container>
          </Box>
          {chargeData && getCouponData && getCouponData.couponList?.length ? (
            <CouponWrapper
              coupon={getCouponData.couponList}
              chargeData={chargeData}
              setCouponData={setCouponData}
            />
          ) : (
            ""
          )}
          {chargeData &&
            ["SUPPORT"].includes(chargeData.product.productType) && (
              <ConcernTextArea
                heading={"【任意】具体的なお悩みや現状を記入する"}
                subHeading={
                  "こちらに具体的なお悩みや現状をご記入ください。事前に記入いただくとスムーズにご案内できます。"
                }
                placeholder={
                  "例：パソコン画面が真っ暗になった、インターネットが接続できない、クレジット会社から不正利用されているとメールが届いた等"
                }
                concernText={concernText}
                setConcernText={setConcernText}
                concernTextError={concernTextError}
                setConcernTextError={setConcernTextError}
              />
            )}
          {chargeData &&
            !["INTERVIEW", "TIP", "ADD"].includes(
              chargeData.product.productType
            ) &&
            reserveNowParam == false && (
              <BuyType setBuyType={setBuyType} buyType={buyType} />
            )}

          <Box className="section-50 bg-dots" component={"section"}>
            <Container className="container">
              <Typography className="section-heading">
                お支払い情報入力
              </Typography>
              <PayJp
                chargeData={chargeData}
                state={state}
                productId={searchParams.get("productId")}
                couponData={couponData}
                buyType={buyType}
                setCoupon={setCouponData}
                concernText={concernText}
                concernTextError={concernTextError}
                setConcernTextError={setConcernTextError}
              />
            </Container>
          </Box>
        </Fragment>
      ) : (
        <LoaderComponent />
      )}
    </Box>
  );
}
